import axios, { AxiosRequestConfig } from "axios";
import getAxiosConfig from "../other/axiosConfig";

const forgotPasswordHelper = async (email: string) => {
  const configData = {
    email,
  };
  const config: AxiosRequestConfig = getAxiosConfig(
    "POST",
    "/users-auth/forgot-password",
    "Content-Type",
    configData,
  );

  const response = await axios(config);

  const { data } = response;
  const { code } = data;

  if (code !== 200) {
    throw Error("Forgot password failed");
  }
};

export default forgotPasswordHelper;
